module.exports = __webpack_public_path__ + "img/aia360.3e97ccb4.jpg";